import { AdminLink } from '../AdminLink';
import { Avatar } from '../Avatar';
import { NotificationsIcon } from 'app/features/notifications/NotificationsIcon';

export const AccountActions = () => (
  <div className="flex shrink-0 items-center gap-1 md:gap-3">
    <NotificationsIcon />
    <AdminLink />
    <Avatar />
  </div>
);
